<template>
  <div class="index-fullpage">
    <img
      class="index-fullpage__img"
      :src="heroSrc"
      alt=""
    >
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      heroSrc: require('./12312313_076.png')
    }
  }
}
</script>

<style lang="less" scoped>
.index-fullpage {
  position: fixed;
  inset: 0;
  z-index: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #000;
}

.index-fullpage__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
</style>
